import { DATA_TEST_ID_PREFIX } from './constants';

const getItemDataTestId = (itemId: string): string => `${DATA_TEST_ID_PREFIX}${itemId}`;

export const getItemDataTestIdSelector = (
	itemDataTestId: (typeof DATA_TEST_IDS)[keyof typeof DATA_TEST_IDS],
): string => `[data-testid="${itemDataTestId}"]`;

export const DATA_TEST_IDS: { [key: string]: string } = {
	TEXT_FIELD: getItemDataTestId('text-field'),
	TOOLTIP: getItemDataTestId('tooltip'),
	WARNING_ICON: getItemDataTestId('warning_icon'),
	ERROR_MESSAGE: getItemDataTestId('error-message'),
};
